import React, { useState, useEffect, Fragment, useContext } from "react";
import Images from "assets/images/imageData";
import { Button } from "react-bootstrap";
import ModalPop from "components/sales/modal/modal";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import Layout from "components/sales/layout/layout";
import CardSection from "components/sales/cardSection/cardSection";
import TableSection from "components/sales/tableSection/tableSection";
import { toast } from "react-toastify";

const InvoiceVisibility = ({
  getChannelPartnerListing,
  channelPartnerListing = [],
  getContractsByChannelPartner,
  contractsListByChannelPartner = [],
  invoiceVisibilityByChannelPartner
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { baseUrl } = useContext(BaseUrl);
  const [isModal, setIsModal] = useState(false);
  const [formData, setFormData] = useState({
    channel_partner_id: null,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [listData, setListData] = useState([]);

  const handleInputChange = (value, key) => {
    setFormData({ ...formData, [key]: value });
  };

  const headers = [
    "Site No",
    "Business Name",
    "City",
    "Contract Type",
    "Contract Status",
    "Contract Visibility",
  ];

  useEffect(() => {
    if (contractsListByChannelPartner?.data?.resultSets?.length > 0) {
      const formattedData = contractsListByChannelPartner.data.resultSets.map(
        (item, index) => ({
          id: item.id || `row-${index}`,
          site_no: item.site_number || "N/A",
          client_name: item.business_name || "N/A",
          city_name: item.city || "N/A",
          contract_type: item.contract_type || "N/A",
          site_status: item.contract_state || "N/A",
          invoice_visibility: item.visibility_status
        })
      );
      setListData(formattedData);
    } else {
      setListData([]);
    }
  }, [contractsListByChannelPartner]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getChannelPartnerListing();
      setIsLoading(false);
    })();
  }, [getChannelPartnerListing]);

  const handleModalHide = () => {
    setIsModal(false);
    setFormData({
      channel_partner_id: null,
    });
    window.location.reload();
  };

  const handleSearch = async () => {
    setIsLoading(true);
    setCurrentPage(1);
    const res = await getContractsByChannelPartner(formData?.channel_partner_id, 1, 15);
    console.log("res: ", res);
    setIsLoading(false);
    if (res?.status === 0 && res?.data?.length === 0) {
      toast.error("No contracts found against this channel partner");
    }
  };

  const onPageChange = async (val) => {
    const selectedPage = val.selected + 1;
    const limit = 15;
    setCurrentPage(selectedPage);
    setIsLoading(true);
    await getContractsByChannelPartner(
      formData?.channel_partner_id,
      selectedPage,
      limit
    );
    setIsLoading(false);
  };

  const handleToggleChange = async (data) => {
    const payload = {
      contract_ids: Array.isArray(data.id) ? data.id : [data.id],
      is_active: data.check ? 1 : 0,
    };
    setIsLoading(true);
    const res = await invoiceVisibilityByChannelPartner(payload);
    console.log("res: ", res);
    setIsLoading(false);
    if (res?.status === 1) {
      toast.error(res?.data?.message);
    } else {
      toast.success(res?.data?.message);
    }

    // Update local state for immediate visual feedback
    const updatedListData = listData.map((item) => {
      if (data.isBulk || item.id === data.id) {
        return {
          ...item,
          invoice_visibility: data.check,
        };
      }
      return item;
    });
    setListData(updatedListData);
    setIsLoading(false);
  };

  return (
    <Layout title={"Channel Partner Invoice Visibility"} isLoading={isLoading}>
      <CardSection title={"Invoice Visibility"}>
        {/* Dropdown Row */}
        <div className="row">
          <div className="col-md-10">
            <DropDownInput
              data={channelPartnerListing?.data}
              label={"Channel Partner Name"}
              required
              errorMsg={"Channel Partner Name is required"}
              isStarRequired
              getIdValue={(val) => {
                handleInputChange(val.id, "channel_partner_id");
              }}
            />
          </div>
          <div className="col-md-2">
            <Button
              variant="primary"
              onClick={handleSearch}
              disabled={isLoading || !formData?.channel_partner_id}
            >
              Search
            </Button>
          </div>
        </div>
      </CardSection>

      {contractsListByChannelPartner &&
      contractsListByChannelPartner.status === 0 &&
      contractsListByChannelPartner.data &&
      contractsListByChannelPartner.data.resultSets &&
      contractsListByChannelPartner.data.resultSets.length > 0 ? (
        <CardSection title={"Invoice List"}>
          <div className="row">
            <TableSection
              data={listData}
              isId={false}
              isMngId={false}
              headers={headers}
              pageCount={Math.ceil(
                contractsListByChannelPartner?.data?.total /
                  contractsListByChannelPartner?.data?.per_page
              )}
              onPageChange={onPageChange}
              currentPage={currentPage}
              onChange={handleToggleChange}
              detailList={contractsListByChannelPartner?.data}
              srNo={contractsListByChannelPartner?.data?.from}
            />
          </div>
        </CardSection>
      ) : null}

      <ModalPop title="" show={isModal} handleModalHide={handleModalHide}>
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default InvoiceVisibility;
